import React from 'react';
import { Construction } from 'lucide-react';

const ExpedienteCard: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden h-full">
      {/* Header */}
      <div className="bg-teal-700 text-white p-6">
        <h3 className="text-xl font-bold">Mi Expediente Escolar</h3>
        <p className="text-teal-100">Estatus actual</p>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col justify-between h-full">
        {/* Status indicator */}
        <div className="mb-6">
          <div className="flex items-center space-x-2 mb-4">
            <div className="w-4 h-4 bg-teal-500 rounded-full flex items-center justify-center">
              <div className="w-2 h-2 bg-white rounded-full"></div>
            </div>
            <span className="text-gray-700 font-medium">DISPONIBLE PRÓXIMAMENTE</span>
          </div>
        </div>

        {/* Under Development Icon */}
        <div className="flex-1 flex items-center justify-center mb-6">
          <div className="text-center">
            {/* Construction/Under Development Icon */}
            <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
              <Construction className="w-12 h-12 text-orange-600" />
            </div>
            
            {/* Under Development Text */}
            <div className="text-orange-600 font-semibold text-sm">
              En Desarrollo
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="text-center">
          <p className="text-gray-700 font-medium">
            ¡Muy pronto podrás consultar fácilmente el estatus de tu expediente escolar!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExpedienteCard;